import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type WithId } from '@framework/form/form/relations/useRelationEditor.ts';
import styled from 'styled-components';
import { type ITableColumnWidget } from '../ITableInputWidget.ts';
import { TableColumnView } from './TableColumnView.tsx';

export const SortableDiv = styled.div`
  padding: 6px 0;

  &:first-child {
    padding-top: 0;
    border-color: transparent;
  }
  & + & {
    border-top: 1px solid ${props => props.theme.colorBorderSecondary}; // #d9d9d9;
    &:last-child {
      padding-bottom: 12px;
    }
  }
`;

export interface ISortableTableColumnItemProps {
  item: ITableColumnWidget;
  uid: string;
  active: WithId<ITableColumnWidget> | null;
  onEdit: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function SortableTableColumnItem(props: ISortableTableColumnItemProps) {
  const { uid, active, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: uid });
  return (
    <SortableDiv
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        // Lo nascondo se è quello selezionato
        visibility: active?.__uid === uid ? 'hidden' : 'visible',
      }}
      {...attributes}
    >
      <TableColumnView {...otherProps} listeners={listeners} />
    </SortableDiv>
  );
}
